import React from 'react';
import { Box, Typography, Chip, Table, TableBody, TableRow, TableCell } from '@mui/material';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

interface ParameterDiff {
  vertexId: string;
  vertexName?: string;
  field: string;
  designValue: unknown;
  executeValue: unknown;
  hasChanges: boolean;
}

interface DefinedVsActualDiffProps {
  diffs: ParameterDiff[];
  stepId?: string;
}

export const DefinedVsActualDiff: React.FC<DefinedVsActualDiffProps> = ({ diffs, stepId }) => {
  const relevantDiffs = stepId
    ? diffs.filter((d) => d.vertexId === stepId && d.hasChanges)
    : diffs.filter((d) => d.hasChanges);

  if (relevantDiffs.length === 0) return null;

  return (
    <Box sx={{ mt: 1, mb: 2, p: 1.5, border: '1px solid', borderColor: 'warning.light', borderRadius: 1, bgcolor: 'warning.50' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <CompareArrowsIcon fontSize="small" color="warning" />
        <Typography variant="subtitle2" color="warning.dark">
          Parameter Changes from Design
        </Typography>
        <Chip label={relevantDiffs.length} size="small" color="warning" />
      </Box>
      <Table size="small">
        <TableBody>
          {relevantDiffs.map((diff, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ fontWeight: 500, width: '30%' }}>{diff.field}</TableCell>
              <TableCell sx={{ color: 'text.secondary', textDecoration: 'line-through' }}>
                {formatValue(diff.designValue)}
              </TableCell>
              <TableCell sx={{ color: 'success.main', fontWeight: 500 }}>
                {formatValue(diff.executeValue)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

function formatValue(value: unknown): string {
  if (value == null) return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
